<template>
  <header class="vv-topbar">
    <button
      class="vv-topbar__burger"
      type="button"
      :aria-label="$t('common.menu')"
      @click="toggleSidebar"
    >
      <!-- inline SVG for the same reason as the sign-out icon: the burger is
           the ONLY way to reach the sidebar below 992px, so it must not depend
           on a remote icon font loading. `.vv-topbar__burger svg` already
           styles this markup. -->
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 7h16" />
        <path d="M4 12h16" />
        <path d="M4 17h16" />
      </svg>
    </button>
    <h1 class="vv-topbar__title">{{ $t("common.portalTitle") }}</h1>
    <div class="vv-topbar__end">
      <notifications-bell></notifications-bell>
      <button
        class="vv-topbar__lang"
        type="button"
        :title="otherLang === 'en' ? 'English' : 'العربية'"
        @click="changeLang(otherLang)"
      >
        <span>{{ otherLang === "en" ? "EN" : "عربي" }}</span>
      </button>
      <!-- Sign out, second entry point. The sidebar already had one, but it is
           a 34px icon-only button inside a panel that collapses behind the
           burger under 992px — so HR users reported there was no sign-out at
           all. This one carries the word, sits in the persistent top bar, and
           is reachable at every width. -->
      <button
        class="vv-topbar__logout"
        type="button"
        data-test="topbar-logout"
        :title="$t('common.logout')"
        @click="logOut"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 17l5-5-5-5" />
          <path d="M20 12H9" />
          <path d="M13 3H6a1 1 0 00-1 1v16a1 1 0 001 1h7" />
        </svg>
        <span>{{ $t("common.logout") }}</span>
      </button>
    </div>
  </header>
</template>

<script>
import NotificationsBell from "./NotificationsBell.vue";
import { apiPost } from "../../api/vivo/http";
import * as tokenStore from "../../api/vivo/token-store";
import { performLogout } from "../../api/vivo/logout";

export default {
  components: { NotificationsBell },
  computed: {
    otherLang() {
      return this.$root.$i18n.locale === "ar" ? "en" : "ar";
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    changeLang(lang) {
      this.$changeRtl(lang);
      this.$root.$i18n.locale = lang;
    },
    logOut() {
      const router = this.$router;
      return performLogout({
        post: apiPost,
        tokenStore: tokenStore,
        redirect: function () {
          router.push("/");
        }
      });
    }
  }
};
</script>
